module.exports = __webpack_public_path__ + "static/media/avatar.9de5b452.png";